document.addEventListener('click', async function(e) {
  const shareBtn = e.target.closest('#share-cart-btn');
  if (!shareBtn) return;

  e.preventDefault();
  const originalHtml = shareBtn.innerHTML;
  shareBtn.innerText = "Capturing Cart...";

  try {
    // 1. Fetch fresh cart data
    const response = await fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' });
    const cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      alert("Your cart is empty!");
      shareBtn.innerHTML = originalHtml;
      return;
    }

    // 2. Build the URL using URLSearchParams (Cleaner & handles special characters)
    const params = new URLSearchParams();
    
    cart.items.forEach((item, index) => {
      params.append(`items[${index}][id]`, item.variant_id);
      params.append(`items[${index}][quantity]`, item.quantity);
      
      // OPTIONAL: Carry over line item properties (if your products have custom text/options)
      if (item.properties) {
        Object.entries(item.properties).forEach(([key, value]) => {
          params.append(`items[${index}][properties][${key}]`, value);
        });
      }
    });

    // 3. Add the redirect back to the cart page
    params.append('return_to', '/cart');

    const shareUrl = `${window.location.origin}/cart/add?${params.toString()}`;

    // 4. Execution logic (Share or Copy)
    if (navigator.share && navigator.canShare && navigator.canShare({ url: shareUrl })) {
      await navigator.share({
        title: 'My Shopping Cart',
        text: 'Check out these items!',
        url: shareUrl
      });
      shareBtn.innerHTML = originalHtml;
    } else {
      await navigator.clipboard.writeText(shareUrl);
      shareBtn.innerText = "Copied All Items!";
      setTimeout(() => { shareBtn.innerHTML = originalHtml; }, 3000);
    }

  } catch (err) {
    console.error('Full Cart Share Error:', err);
    shareBtn.innerHTML = originalHtml;
    alert("Error capturing all items. Please try again.");
  }
});
console.log("-------------------------------------- share cart")